import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import LibraryItem from '@/repositories/data/libraryitem/LibraryItem';

export default class LibraryItemRepository extends BaseCrudRepository<number, LibraryItem, LibraryItem> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/library-item');
    }
}
